import React from "react";

import Table from "./Table";
import TableHeader from "./TableHeader";

import { createNestedData } from "../utils";

const DifferentialTable = ({ description, setActiveTab }) => {
  const differentialData = description.differential.element.map(
    delement => delement.id
  );
  const structuredDifferentialData = description.snapshot.element.filter(
    element => differentialData.includes(element.id)
  );
  structuredDifferentialData[0].children = createNestedData(
    structuredDifferentialData.slice(1)
  );

  return (
    <div className="flex flex-col">
      <TableHeader />
      <Table
        data={[structuredDifferentialData[0]]}
        setActiveTab={setActiveTab}
        elementIds={differentialData}
      />
    </div>
  );
};

export default DifferentialTable;
